import { useQuery } from "@tanstack/react-query";
import { getReward } from "./rewardsApi";

export const useRewardWithId = (rewardId: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: ["rewards", rewardId],
    queryFn: ({ signal }) => getReward(rewardId!, signal),
    enabled: rewardId !== undefined,
  });

  return { data, isLoading };
};
